// Excel / Excel Online / Microsoft 365 clipboard parsing.

function parseTsv(text) {
    const rows = [];
    let row = [], cell = "", q = false;
    const s = text.replace(/\r\n?/g, "\n");
    for (let i = 0; i < s.length; i++) {
        const ch = s[i];
        if (q) {
            if (ch === '"' && s[i + 1] === '"') { cell += '"'; i++; }
            else if (ch === '"') q = false;
            else cell += ch;
        } else if (ch === '"' && cell === "") q = true;
        else if (ch === "\t") { row.push(cell); cell = ""; }
        else if (ch === "\n") { row.push(cell); rows.push(row); row = []; cell = ""; }
        else cell += ch;
    }
    if (cell !== "" || row.length) { row.push(cell); rows.push(row); }
    return rows;
}

function parseHtml(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const trs = [...doc.querySelectorAll("tr")];
    if (!trs.length) return null;
    const out = [];
    trs.forEach((tr, ri) => {
        out[ri] = out[ri] || [];
        let ci = 0;
        [...tr.children].filter((n) => /^T[DH]$/.test(n.tagName)).forEach((td) => {
            while (out[ri][ci] !== undefined) ci++;
            const v = (td.innerText ?? td.textContent ?? "").replace(/\u00a0/g, " ").trim();
            const cs = Math.max(1, +td.getAttribute("colspan") || 1), rs = Math.max(1, +td.getAttribute("rowspan") || 1);
            for (let a = 0; a < rs; a++) for (let b = 0; b < cs; b++) {
                out[ri + a] = out[ri + a] || [];
                out[ri + a][ci + b] = a === 0 && b === 0 ? v : "";
            }
            ci += cs;
        });
    });
    return out.map((r) => Array.from(r, (v) => v ?? ""));
}

export function readClipboardGrid(cd) {
    const text = cd.getData("text/plain");
    const html = cd.getData("text/html");
    let grid = text ? parseTsv(text) : null;
    if ((!grid || !grid.length || (grid.length === 1 && grid[0].length === 1 && html && /<t[dr]/i.test(html))) && html) grid = parseHtml(html) || grid;
    if (!grid || !grid.length) return null;
    while (grid.length > 1 && grid[grid.length - 1].every((v) => String(v).trim() === "")) grid.pop();
    const w = Math.max(...grid.map((r) => r.length));
    return grid.map((r) => [...r, ...Array(w - r.length).fill("")]);
}

// "3 635", "1.200,50", "1,200.50", "0,5", "1200 mm" -> number; null if not numeric.
export function parseNumber(value) {
    if (value === "" || value == null) return null;
    if (typeof value === "number") return value;
    let s = String(value).replace(/[\s\u00a0\u202f']/g, "").replace(/[a-zA-Z%²³]+$/g, "").replace(/^[^\d\-+.,]+/, "");
    if (!s) return null;
    const lc = s.lastIndexOf(","), ld = s.lastIndexOf(".");
    if (lc > -1 && ld > -1) s = lc > ld ? s.replace(/\./g, "").replace(",", ".") : s.replace(/,/g, "");
    else if (lc > -1) s = s.match(/,/g).length > 1 ? s.replace(/,/g, "") : s.replace(",", ".");
    else if ((s.match(/\./g) || []).length > 1) s = s.replace(/\./g, "");
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
}

const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ø/g, "o").replace(/æ/g, "ae").replace(/[^a-z0-9]/g, "");
const ALIASES = {
    width: ["plotis", "bredde", "width", "b", "w", "pl"],
    height: ["aukstis", "hoyde", "hojde", "height", "h", "auk"],
    qty: ["ant", "kiekis", "antall", "qty", "vnt", "stk", "kiek"],
    position: ["post", "pos", "poz", "pozicija", "position", "posisjon"],
};

// If the first pasted row is a header matching table columns, returns column index per pasted column (or -1).
export function headerMapping(firstRow, columns) {
    if (!firstRow.length || firstRow.some((v) => parseNumber(v) !== null)) return null;
    const used = new Set();
    const map = firstRow.map((h) => {
        const n = norm(h);
        if (!n) return -1;
        let idx = columns.findIndex((c, i) => !used.has(i) && !c.calc && (norm(c.label) === n || norm(c.key) === n));
        if (idx < 0) {
            const key = Object.keys(ALIASES).find((k) => ALIASES[k].includes(n));
            idx = key ? columns.findIndex((c, i) => !used.has(i) && c.key === key) : -1;
        }
        if (idx >= 0) used.add(idx);
        return idx;
    });
    return map.some((i) => i >= 0) ? map : null;
}
